import * as React from 'react';
import { Link as RouterLink } from 'react-router-dom';

import { routes } from 'defs';
import { HistoryType } from 'types/withRouter';

export type AnamnesisStartProps = {
	isAuthenticated?: boolean;
	router: HistoryType;
};

export default class Start extends React.Component<AnamnesisStartProps> {
	public static displayName = 'AnamnesisStart';

	public componentDidUpdate() {
		const { isAuthenticated, router } = this.props;

		if (isAuthenticated) {
			router.push(routes.anamnesis.selectCoach.href);
		}
	}

	public render() {
		return (
			<div>
				<h2 style={{ margin: '0 0 10px 0' }}>Startstufe der Anamnese</h2>
				<RouterLink className="a-link a-link--button" to={routes.anamnesis.selectCoach.href}>
					Zum Coach
				</RouterLink>
			</div>
		);
	}
}
